// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/@vue/cli-service/node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "[dir] .action-container[data-v-f0109de0] {\n  border: 0.5px dashed rgb(var(--vs-primary));\n}\n", ""]);
// Exports
module.exports = exports;
